export default "__VITE_ASSET__DSsH8N64__"